var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tags-box"},[_c('ul',_vm._l((_vm.tags),function(tag,key){return _c('li',{key:key},[_c('router-link',{attrs:{"to":{name: 'TagsDetails', params: {id: tag.id}}}},[_c('span',[_vm._v(_vm._s(tag.pl))])])],1)}),0)])}
var staticRenderFns = []

export { render, staticRenderFns }